import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';

import { Button, UncontrolledTooltip } from 'reactstrap';

export default function PageTitleAlt2(props) {
    const { heading, icon, subheading, showCreateBtn } = props;
    const history = useHistory();

    const onSubmitRefuse = useCallback(async () => {
        history.push('/group/create');
    }, [history]);

    return (
        <div className="app-page-title">
            <div className="page-title-wrapper">
                <div className="page-title-heading">
                    <div
                        className={cx('page-title-icon rounded-circle', {
                            'd-none': false,
                        })}
                    >
                        <i className={icon} />
                    </div>
                    <div>
                        {heading}
                        <div
                            className={cx('page-title-subheading', {
                                'd-none': false,
                            })}
                        >
                            {subheading}
                        </div>
                    </div>
                </div>
                {showCreateBtn && (
                    <div className="page-title-actions">
                        <Button
                            className="mb-2 mr-2"
                            color="primary"
                            onClick={onSubmitRefuse}
                            id="createAGroupId"
                        >
                            Create group
                        </Button>
                        <UncontrolledTooltip 
                            placement="left" 
                            target={'createAGroupId'}
                        >
                            Create a new Group
                        </UncontrolledTooltip>
                    </div>
                )}
            </div>
        </div>
    );
}
